import {
  backend_url,
  uninterceptedAxiosInstance,
  qs,
} from "../common/commonVariables";

export const createNewWorkOrder = async (
  title,
  description,
  customer,
  location,
  orderType,
  dueDate,
  dueTime,
  repeatEvery,
  daysRepeat,
  repeatEveryWeek,
  repeatEveryMonth,
  repeatMonthDay,
  repeatEveryYear,
  endRepeat,
  estimationTime,
  laborCost,
  priority,
  category,
  people,
  teams,
  assets,
  part,
  procedure,
  image,
  attachments,
  organisation = "",
  createdByUser = null,
  qrcode,
  work_request,
  set,
  area,
  startDate,
  startTime,
  primaryAssignee,
  isRequiredSignature
) => {
  try {
    let params = {
      title,
      description,
      customer,
      location,
      orderType,
      dueDate,
      dueTime,
      repeatEvery,
      startDate,
      startTime,
      daysRepeat,
      repeatEveryWeek,
      repeatEveryMonth,
      repeatMonthDay,
      repeatEveryYear,
      endRepeat,
      estimationTime,
      laborCost,
      priority,
      category,
      people,
      teams,
      assets,
      part,
      procedure,
      image,
      status: "open",
      organisation,
      createdByUser,
      qrcode,
      attachments,

      work_request,
      set,
      area,
      primaryAssignee,
      isRequiredSignature,
    };

    if (image)
      params = {
        ...params,
        image: image,
      };

    const response = await uninterceptedAxiosInstance.post(
      backend_url + "work-orders",
      { data: params },
      {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
        },
      }
    );

    let the_response = response;

    return the_response;
  } catch (err) {
    if (err.response) {
    } else if (err.request) {
    } else {
    }

    return {
      status: err.response.status,
      error: err.response?.data?.error,
    };
  }
};

export const updateWorkOrderStatus = async (
  id,
  status,
  message,
  orderType,
  isConfirmed = false,
  addedSignature
) => {
  try {
    const response = await uninterceptedAxiosInstance.put(
      backend_url + `work-orders/${id}`,
      {
        data: {
          status,
          orderType,
          reason: [
            {
              comment: message ? message : null,
              status: status,
            },
          ],
          ...(isConfirmed ? { isConfirmed: true } : {}),
         ...(addedSignature ? { signature: [{ file: addedSignature }] } : {}),
        },
      }
    );

    let the_response = response;

    return the_response;
  } catch (err) {
    if (err.response) {
    } else if (err.request) {
    } else {
    }

    return {
      status: err.response.status,
      error: err.response?.data?.error,
    };
  }
};

export const createNewSchedule = async (
  title,
  description,
  customer,
  location,
  orderType,
  dueDate,
  dueTime,
  repeatEvery,
  daysRepeat,
  repeatEveryWeek,
  repeatEveryMonth,
  repeatMonthDay,
  repeatEveryYear,
  endRepeat,
  estimationTime,
  laborCost,
  priority,
  category,
  people,
  teams,
  assets,
  part,
  procedure,
  image,
  attachments,
  organisation = "",
  createdByUser = null,
  endDate = "",
  endType = "",
  qrcode,
  work_request,
  set,
  area,
  startDate,
  startTime,
  primaryAssignee,
  isRequiredSignature
) => {
  try {
    let params = {
      title,
      description,
      customer,
      location,
      orderType,
      dueDate,
      dueTime,
      repeatEvery,
      daysRepeat,
      repeatEveryWeek,
      repeatEveryMonth,
      repeatMonthDay,
      repeatEveryYear,
      endRepeat,
      estimationTime,
      laborCost,
      priority,
      category,
      people,
      teams,
      assets,
      part,
      startDate,
      startTime,
      procedure,
      status: "open",
      organisation,
      createdByUser,
      attachments,
      endDate,
      endType,
      qrcode,
      work_request,
      set,
      area,
      primaryAssignee,
      isRequiredSignature,
    };

    if (image)
      params = {
        ...params,
        image: image,
      };

    const response = await uninterceptedAxiosInstance.post(
      backend_url + "schedule-work-order",
      { data: params },
      {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
        },
      }
    );

    let the_response = response;

    return the_response;
  } catch (err) {
    if (err.response) {
    } else if (err.request) {
    } else {
    }

    return {
      status: err.response.status,
      error: err.response?.data?.error,
    };
  }
};

export const addNewComment = async (
  workOrderID = null,
  comment,
  image = []
) => {
  try {
    let params = {
      comment,
      image,
    };

    const response = await uninterceptedAxiosInstance.post(
      backend_url + `work-order/${workOrderID}/comment`,
      { data: params },
      {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
        },
      }
    );
    let the_response = response;

    return the_response;
  } catch (err) {
    if (err.response) {
    } else if (err.request) {
    } else {
    }

    return {
      status: err?.response?.status,
    };
  }
};

export const updateCloseNotes = async (notes, id) => {
  try {
    let params = {
      closeOutNotes: notes,
    };

    const response = await uninterceptedAxiosInstance.put(
      backend_url + `work-order/close-out-notes/${id}`,
      { data: params },
      {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
        },
      }
    );
    let the_response = response;
    return the_response;
  } catch (err) {
    return {
      status: err?.response?.status,
    };
  }
};

export const addWOAttachments = async (files, id) => {
  try {
    let params = {
      attachments: files,
    };

    const response = await uninterceptedAxiosInstance.put(
      backend_url + `work-order/files/${id}`,
      { data: params },
      {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
        },
      }
    );
    let the_response = response;
    return the_response;
  } catch (err) {
    return {
      status: err?.response?.status,
    };
  }
};

export const deleteWOAttachments = async (fileID, id) => {
  try {
    const response = await uninterceptedAxiosInstance.delete(
      backend_url + `work-order/file/${fileID}?workOrderId=${id}`,
      {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
        },
      }
    );
    let the_response = response;
    return the_response;
  } catch (err) {
    return {
      status: err?.response?.status,
    };
  }
};

export const updateWorkOrder = async (
  id,
  title,
  description,
  customer,
  location,
  orderType,
  dueDate,
  dueTime,
  repeatEvery,
  daysRepeat,
  repeatEveryWeek,
  repeatEveryMonth,
  repeatMonthDay,
  repeatEveryYear,
  endRepeat,
  estimationTime,
  laborCost,
  priority,
  category,
  people,
  teams,
  assets,
  part,
  procedure,
  image,
  attachments,
  status = "",
  endDate = null,
  endType = "",
  qrcode,
  isSingle,
  organisation,
  set,
  area,
  startDate,
  startTime,
  closeOutNotes,
  primaryAssignee,
  isRequiredSignature,

) => {
  try {
    let params = {
      title,
      description,
      customer,
      location,
      orderType,
      dueDate,
      dueTime,
      repeatEvery,
      daysRepeat,
      repeatEveryWeek,
      repeatEveryMonth,
      repeatMonthDay,
      repeatEveryYear,
      endRepeat,
      estimationTime,
      laborCost,
      priority,
      category,
      people,
      teams,
      assets,
      part,
      procedure,
      startDate,
      startTime,
      image,
      attachments,
      endDate,
      endType,
      qrcode,
      organisation,
      set,
      area,
      closeOutNotes,
      primaryAssignee,
      isRequiredSignature,
    };

    if (orderType == "scheduled") {
      params.isSingle = !isSingle;
    }


    const response = await uninterceptedAxiosInstance.put(
      backend_url + "work-orders/" + id,
      { data: params },
      {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
        },
      }
    );

    let the_response = response;

    return the_response;
  } catch (err) {
    if (err.response) {
    } else if (err.request) {
    }

    return {
      status: err.response.status,
      error: err.response?.data?.error,
    };
  }
};

export const updatePartWorkOrder = async (
  part,
  set,
  workOrder,
  organisation
) => {
  try {
    let params = {
      part,
      set,
      workOrder,
      organisation,
    };

    const response = await uninterceptedAxiosInstance.post(
      backend_url + "work-order/parts",
      { data: params },
      {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
        },
      }
    );

    let the_response = response;

    return the_response;
  } catch (err) {
    if (err.response) {
    } else if (err.request) {
    } else {
    }

    return {
      status: err.response.status,
      error: err.response?.data?.error,
    };
  }
};

export const updateWorkOrderAssign = async (id, teams, people, orderType) => {
  try {
    let params = {
      id,
      teams,
      people,
      orderType,
    };

    const response = await uninterceptedAxiosInstance.put(
      backend_url + "work-orders/" + id,
      { data: params },
      {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
        },
      }
    );

    let the_response = response;

    return the_response;
  } catch (err) {
    if (err.response) {
    } else if (err.request) {
    } else {
    }

    return {
      status: err.response.status,
      error: err.response?.data?.error,
    };
  }
};

export const updateWorkOrderPrimaryAssign = async (
  id,
  primaryAssignee,
  teams,
  people,
  orderType,
  isPrimary
) => {
  try {
    let params = {
      orderType,
    };

    if (teams !== null) {
      params.teams = teams;
    }
    if (people !== null) {
      params.people = people;
    }

    if (isPrimary) {
      params.people = people;
      params.primaryAssignee = primaryAssignee;
    }

    const response = await uninterceptedAxiosInstance.put(
      backend_url + "work-orders/" + id,
      { data: params },
      {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
        },
      }
    );

    let the_response = response;

    return the_response;
  } catch (err) {
    if (err.response) {
    } else if (err.request) {
    } else {
    }

    return {
      status: err.response.status,
      error: err.response?.data?.error,
    };
  }
};

export const addLaborTime = async (
  workOrder,
  organisation,
  assignee,
  hourlyRate,
  startTime,
  duration,
  category
) => {
  try {
    let params = {
      workOrder,
      organisation,
      assignee,
      hourlyRate,
      startTime,
      duration,
      category,
    };

    const response = await uninterceptedAxiosInstance.post(
      backend_url + "work-order-log/add-time",
      { data: params },
      {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
        },
      }
    );

    let the_response = response;

    return the_response;
  } catch (err) {
    if (err.response) {
    } else if (err.request) {
    } else {
    }

    return {
      status: err.response.status,
      error: err.response?.data?.error,
    };
  }
};

export const editLaborTime = async (
  organisation,
  assignee,
  hourlyRate,
  startTime,
  duration,
  category,
  id,
  logId
) => {
  try {
    let params = {
      organisation,
      assignee,
      hourlyRate,
      startTime,
      duration,
      category,
    };

    const response = await uninterceptedAxiosInstance.put(
      backend_url + `work-order-log/update-time/${id}?logId=${logId}`,
      { data: params },
      {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
        },
      }
    );

    let the_response = response;

    return the_response;
  } catch (err) {
    if (err.response) {
    } else if (err.request) {
    } else {
    }

    return {
      status: err.response.status,
      error: err.response?.data?.error,
    };
  }
};

export const addCostData = async (
  workOrder,
  organisation,
  createdByUser,
  assignee,
  cost,
  dateTime,
  description,
  category
) => {
  try {
    let params = {
      workOrder,
      organisation,
      createdByUser,
      assignee,
      cost,
      dateTime,
      description,
      category,
    };

    const response = await uninterceptedAxiosInstance.post(
      backend_url + "work-order-costs",
      { data: params },
      {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
        },
      }
    );

    let the_response = response;

    return the_response;
  } catch (err) {
    if (err.response) {
    } else if (err.request) {
    } else {
    }

    return {
      status: err.response.status,
      error: err.response?.data?.error,
    };
  }
};

export const editCostData = async (
  workOrder,
  organisation,
  updatedByUser,
  assignee,
  cost,
  dateTime,
  description,
  category,
  id
) => {
  try {
    let params = {
      workOrder,
      organisation,
      updatedByUser,
      assignee,
      cost,
      dateTime,
      description,
      category,
    };

    const response = await uninterceptedAxiosInstance.put(
      backend_url + `work-order-costs/${id}`,
      { data: params },
      {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
        },
      }
    );

    let the_response = response;

    return the_response;
  } catch (err) {
    if (err.response) {
    } else if (err.request) {
    } else {
    }

    return {
      status: err.response.status,
      error: err.response?.data?.error,
    };
  }
};

export const editWoPartData = async (
  part,
  location,
  unitCost,
  quantity,
  totalCost,
  workOrderId,
  type = "Part",
  id
) => {
  try {
    let params = {
      location,
      unitCost,
      quantity,
      totalCost,
      workOrderId,
    };

    if (type == "Part") {
      params.part = part;
    } else {
      params.set = part;
    }

    const response = await uninterceptedAxiosInstance.put(
      backend_url + `work-order/parts/${id}`,
      { data: params },
      {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
        },
      }
    );

    let the_response = response;

    return the_response;
  } catch (err) {
    if (err.response) {
    } else if (err.request) {
    } else {
    }

    return {
      status: err.response.status,
      error: err.response?.data?.error,
    };
  }
};

export const getAllComments = async (
  workOrderID = "",
  page = 1,
  pageSize = 10
) => {
  const queryParams = {};

  if (page && pageSize) {
    queryParams["page"] = String(page);
    queryParams["pageSize"] = String(pageSize);
  }

  const query = qs.stringify(queryParams, {
    encodeValuesOnly: true,
  });

  try {
    const response = await uninterceptedAxiosInstance.get(
      backend_url + `work-order/${workOrderID}/comment?${query}`,
      {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
        },
      }
    );

    let the_response = response.data.data;

    let dataObj = {
      response: the_response,
      status: response.status,
      pagination: response.data.meta.pagination,
    };

    return dataObj;
  } catch (err) {
    if (err.response) {
    } else if (err.request) {
    } else {
    }

    return {
      status: err.response.status,
      error: err.response?.data?.error,
    };
  }
};

export const getLaborTabData = async (ID) => {
  try {
    const response = await uninterceptedAxiosInstance.get(
      backend_url + `work-order-log/getUsersLogs/${ID}`,
      {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
        },
      }
    );

    let the_response = response.data;

    return the_response;
  } catch (err) {
    if (err.response) {
    } else if (err.request) {
    } else {
    }
  }
};

export const getCostTabData = async (organisationID, ID) => {
  let costFilter = {
    organisation: {
      id: {
        $eq: organisationID,
      },
    },
    workOrder: {
      id: {
        $eq: ID,
      },
    },
  };

  const queryParams = {
    sort: ["id:desc"],
    filters: costFilter,
    populate: "*",
  };

  const query = qs.stringify(queryParams, {
    encodeValuesOnly: true,
  });

  try {
    const response = await uninterceptedAxiosInstance.get(
      backend_url + `work-order-costs/?${query}`,
      {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
        },
      }
    );

    let the_response = {
      data: response.data.data,
      totalCost: response.data.totalCost,
    };

    return the_response;
  } catch (err) {
    if (err.response) {
    } else if (err.request) {
    } else {
    }
  }
};

export const deleteLaborTabData = async (ID, logId) => {
  try {
    const response = await uninterceptedAxiosInstance.delete(
      backend_url + `work-order-log/delete-time/${ID}?logId=${logId}`,
      {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
        },
      }
    );

    let the_response = response;

    return the_response;
  } catch (err) {
    if (err.response) {
    } else if (err.request) {
    } else {
    }
  }
};

export const deleteCostTabData = async (ID) => {
  try {
    const response = await uninterceptedAxiosInstance.delete(
      backend_url + `work-order-costs/${ID}`,
      {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
        },
      }
    );

    let the_response = response;

    return the_response;
  } catch (err) {
    if (err.response) {
    } else if (err.request) {
    } else {
    }
  }
};

export const getAllWOParts = async (woId = "") => {
  const queryParams = {
    workOrderId: woId,

    populate: [],
  };

  const query = qs.stringify(queryParams, {
    encodeValuesOnly: true,
  });
  try {
    const response = await uninterceptedAxiosInstance.get(
      backend_url + `work-order/parts?${query}`,
      {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
        },
      }
    );

    let the_response = response.data;

    return the_response;
  } catch (err) {
    if (err.response) {
      return err.response.data;
    } else if (err.request) {
    } else {
    }
  }
};

export const getWOByDetails = async (organisationID = "", id) => {
  let jobTitleFilters = {
    organisation: {
      id: {
        $eq: organisationID,
      },
    },

    id: {
      $eq: id,
    },
  };

  const queryParams = {
    filters: jobTitleFilters,
    populate: [
      "part",
      "attachments",
      "set",
      "people.profileImage",
      "people.userProfile",
      "people.role",
      "teams",
      "teams.images",
      "primaryAssignee.profileImage",
      "primaryAssignee.userProfile",
      "primaryAssignee.role",
    ],
  };

  const query = qs.stringify(queryParams, {
    encodeValuesOnly: true,
  });
  try {
    const response = await uninterceptedAxiosInstance.get(
      backend_url + `work-orders?${query}`,
      {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
        },
      }
    );

    let the_response = response?.data?.data;

    return the_response;
  } catch (err) {
    if (err.response) {
      return err.response.data;
    } else if (err.request) {
    } else {
    }
  }
};

export const getAllSchedualWOList = async (organisationID = "", id) => {
  let jobTitleFilters = {
    organisation: {
      id: {
        $eq: organisationID,
      },
    },

    unique_hash: {
      $eq: id,
    },

    status: {
      $ne: "cancelled",
    },
  };

  const queryParams = {
    filters: jobTitleFilters,
    populate: [],
  };

  const query = qs.stringify(queryParams, {
    encodeValuesOnly: true,
  });
  try {
    const response = await uninterceptedAxiosInstance.get(
      backend_url + `work-orders?${query}`,
      {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
        },
      }
    );
    let the_response = response;

    return the_response;
  } catch (err) {
    if (err.response) {
      return err.response.data;
    } else if (err.request) {
    } else {
    }
  }
};

export const getAllWOPartsData = async (organisationID = "") => {
  const query = qs.stringify(
    {
      organisation: organisationID,
    },
    {
      encodeValuesOnly: true,
    }
  );

  try {
    const response = await uninterceptedAxiosInstance.get(
      backend_url + `work-order/parts-and-sets?${query}`,
      {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
        },
      }
    );

    return response.data;
  } catch (err) {
    if (err.response) {
    } else if (err.request) {
    } else {
    }
  }
};

export const getAllWorkOrders = async (
  organisationID = "",
  searchName = "",
  page = 1,
  pageSize = 99999,
  assignee = [],
  status = [],
  priority = [],
  category = [],
  customers = [],
  locations = [],
  dueDate = [],
  serialNumber = "",
  teams = [],
  sort = [],
  role = "",
  allIds = [],
  currentUserId = "",
  orderType = [],
  fromCal = false
) => {
  let assetFilters = {
    organisation: {
      id: {
        $eq: organisationID,
      },
    },

    $or: [
      {
        people: {
          id: {
            $in: assignee,
          },
        },
      },
      {
        primaryAssignee: {
          id: {
            $in: assignee,
          },
        },
      },
    ],

    location: {
      id: {
        $in: locations,
      },
    },
    teams: {
      id: {
        $in: teams,
      },
    },
    customer: {
      id: {
        $in: customers,
      },
    },
    category: {
      $in: category,
    },
    work_request: {},
  };

  if (
    locations?.length == 0 &&
    role !== "super_admin" &&
    role !== "requester"
  ) {
    assetFilters.location = {
      id: {
        $in: allIds,
      },
    };
  } else if (role === "requester") {
    assetFilters.work_request.submittedBy = {
      id: {
        $eq: currentUserId,
      },
    };
  } else {
    assetFilters.location = {
      id: {
        $in: locations,
      },
    };
  }

  if (dueDate.length === 1) {
    assetFilters.dueDate = {
      $gte: dueDate[0],
    };
  } else if (dueDate.length === 2) {
    assetFilters.dueDate = {
      $gte: dueDate[0],
      $lte: dueDate[1],
    };
  }

  if (serialNumber) {
    assetFilters.id = {
      $in: serialNumber,
    };
  }

  if (status) {
    assetFilters.status = {
      $eq: status[0],
    };
  }
  if (orderType) {
    assetFilters.orderType = {
      $eq: orderType[0],
    };
  }

  if (priority) {
    assetFilters.priority = {
      $eq: priority[0],
    };
  }

  const queryParams = {
    sort: fromCal
      ? ["countNumId:desc"]
      : sort.length > 0
      ? sort
      : ["countNumId:desc"],
    filters: assetFilters,
    _q: searchName,
    populate: [
      "area",
      "assets.image",
      "assets",
      "attachments",
      "createdByUser.profileImage",
      "createdByUser",
      "customer",
      'signature',
      'signature.file',
      'signature.addedByUser',
      'signature.addedByUser.profileImage',
      "daysRepeat",
      "file",
      "image",
      "location",
      "part.location",
      "part.part",
      "part",
      "parts.image",
      "parts",
      "people.profileImage",
      "people.role",
      "people.userProfile",
      "primaryAssignee.profileImage",
      "primaryAssignee.role",
      "primaryAssignee.supervisor",
      "primaryAssignee.userProfile",
      "procedure.assets.location",
      "procedure.assets",
      "procedure.createdByUser",
      "procedure.createdByUser",
      "procedure.fields.attachments",
      "procedure.fields.attachments",
      "procedure.fields.logics",
      "procedure.fields.options",
      "procedure.fields",
      "procedure.headers.fields.attachments",
      "procedure.headers.fields.logics",
      "procedure.headers.fields.options",
      "procedure.headers.fields",
      "procedure.headers",
      "procedure.locations",
      "procedure.parts",
      "reason.image",
      "reason.user",
      "reason",
      "report.headerReportItems.action.people.role",
      "report.headerReportItems.action.teams",
      "report.headerReportItems.actions.evidences",
      "report.headerReportItems.actions.workOrder",
      "report.headerReportItems.actions.workOrder",
      "report.headerReportItems.actions",
      "report.headerReportItems.file",
      "report.headerReportItems.options",
      "report.headerReportItems.reportItems.action.people.role",
      "report.headerReportItems.reportItems.action.teams",
      "report.headerReportItems.reportItems.actions.evidences",
      "report.headerReportItems.reportItems.actions.workOrder",
      "report.headerReportItems.reportItems.actions.workOrder",
      "report.headerReportItems.reportItems.actions",
      "report.headerReportItems.reportItems.file",
      "report.headerReportItems.reportItems.options",
      "report.headerReportItems.reportItems",
      "report.headerReportItems",
      "report.otherCosts",
      "report.part.amount",
      "report.part.part",
      "report.parts.location",
      "report.parts.part.image",
      "report.reportItems.action.people.role",
      "report.reportItems.action.teams",
      "report.reportItems.actions.evidences",
      "report.reportItems.actions.workOrder",
      "report.reportItems.actions",
      "report.reportItems.file",
      "report.reportItems.options",
      "report.reportItems",
      "report.sets.location",
      "report.sets.set",
      "report.timeTracking.user",
      "report.timeTracking.user",
      "report.user",
      "set.location",
      "set.set",
      "set",
      "sets",
      "teams.images",
      "teams.users",
      "teams.users.profileImage",
      "teams",
      "updatedByUser",
      "work_request",
      "work_request.submittedBy",
      "work-order-log",
    ],
  };

  if (page && pageSize) {
    queryParams["pagination[page]"] = String(page);
    queryParams["pagination[pageSize]"] = String(pageSize);
  }
  const query = qs.stringify(queryParams, {
    encodeValuesOnly: true,
  });

  try {
    const response = await uninterceptedAxiosInstance.get(
      backend_url + `work-orders?${query}`,
      {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
        },
      }
    );

    let the_response = response.data.data;

    let dataObj = {
      response: the_response,
      status: response.status,
      pagination: response.data.meta.pagination,
    };

    return dataObj;
  } catch (err) {
    if (err.response) {
    } else if (err.request) {
    } else {
    }
  }
};

export const getAllWorkOrderByID = async (ID) => {
  try {
    const response = await uninterceptedAxiosInstance.get(
      backend_url + "work-orders/" + ID + "?sort[0]=id",
      {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
        },
      }
    );

    let the_response = response.data.data;

    return the_response;
  } catch (err) {
    if (err.response) {
    } else if (err.request) {
    } else {
    }
  }
};

export const deletePartFromWO = async (ID, WOId, isPart = true) => {
  try {
    const response = await uninterceptedAxiosInstance.delete(
      backend_url +
        `work-order/parts/${ID}?workOrderId=${WOId}&isPart=${isPart}`,
      {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
        },
      }
    );

    let the_response = response;

    return the_response;
  } catch (err) {
    if (err.response) {
    } else if (err.request) {
    } else {
    }

    return {
      status: err.response.status,
      error: err.response?.data?.error,
    };
  }
};

export const deleteWorkOrder = async (ID, deleteSeries, reason) => {
  try {
    let params = {
      data: [
        {
          id: ID,
          deleteReason: reason,
          isSeries:deleteSeries ? true : false,
        },
      ],
    };

    const response = await uninterceptedAxiosInstance.post(
      backend_url + "work-order/removeWorkOrders",
      params,
      {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
        },
      }
    );

    let the_response = response?.data?.data?.response[0];

    return the_response;
  } catch (err) {
    if (err.response) {
    } else if (err.request) {
    } else {
    }

    return {
      status: err.response.status,
      error: err.response?.data?.error,
    };
  }
};

export const downloadWorkOrderPdf = async (ID) => {
  try {
    const response = await uninterceptedAxiosInstance.get(
      backend_url + "pdf/work-orders/" + ID,

      {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
        },
        responseType: "arraybuffer",
      }
    );

    let the_response = response;

    return the_response;
  } catch (err) {
    return err.response;
  }
};
